import { AxiosError } from 'axios';
import { useMutation } from 'react-query';
import { API_HOST } from '@/config';
import { useToast } from '@/hooks/useToast';
import { ErrorMessage, extractServerErrorMsg, SURVEYS_QUERY_KEY } from '@/queries';
import { queryClient } from '@/reactQueryClient';
import client, { ApiRoutes } from '@/store/client';
import { Survey, CreateOrUpdateSurveyRequest } from '../types';

export const useUpdateSurvey = () => {
  const { toast } = useToast();

  const updateSurveyMutation = useMutation(
    ({ featureId, survey }: CreateOrUpdateSurveyRequest) => {
      return client.patch<Survey>(
        `${API_HOST}/${ApiRoutes.Surveys}/${featureId}/surveys/${survey.id}`,
        survey,
      );
    },
    {
      onError: (errorResponse: AxiosError) => {
        toast(extractServerErrorMsg(errorResponse, 'Failed to update survey.'), {
          variant: 'error',
        });
      },
      onSuccess: (_, { featureId }) => {
        queryClient.invalidateQueries([SURVEYS_QUERY_KEY, featureId]);
        toast('Survey updated successfully.', {
          variant: 'success',
        });
      },
    },
  );

  const { mutateAsync: updateSurvey, isLoading, error } = updateSurveyMutation;
  const serverErrors: ErrorMessage[] = error?.response?.data?.errors || [];

  return { isLoading, serverErrors, updateSurvey };
};
